import axios from 'axios'
const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}/admin`

const login = async (param) => {
  const result = await axios.post(`${baseUrl}/login`, param)
  return result
}

const logout = async (param) => {
  const result = await axios.post(`${baseUrl}/logout`, param)
  return result
}

const loginApi = {
  login,
  logout,
}

export default loginApi
